import React from "react";
import { Flex } from 'theme-ui'
import TransLinkWrapper from "./transLinkWrapper";

const SiteHeader = ({ headerVariant }) => {
    return (
        <Flex sx={{ justifyContent: 'space-between' }}  variant={headerVariant}>
            <TransLinkWrapper linkLabel="WHP Creative - Home" linkTo='/' >
                <svg version="1.1" x="0px" y="0px" viewBox="0 0 185.2 55.7" >
                    <polygon  points="112.4,19.6 96,19.6 96,19.7 104.2,37 "/>
                    <polygon points="90.8,2.2 74.4,37 82.6,54.4 90.8,37 82.6,19.6 99,19.6 99,19.6 107.2,2.2 "/>
                    <polygon  points="32.7,2.2 16.2,37 24.4,54.4 49.1,2.2 "/>
                    <circle  cx="8.7" cy="8.7" r="7.6"/>
                    <polygon  points="120.6,2.2 104.2,37 112.4,54.4 137,2.2 "/>
                    <path  d="M176.8,3.8l-1.6,3.5l-1.9,3.9l-11.1,23.6c1.5,0.4,3,0.7,4.7,0.7c9.6,0,17.3-7.8,17.3-17.3 C184.2,12.2,181.3,7,176.8,3.8z"/>
                    <polygon  points="149,2.2 132.6,37 140.8,54.4 165.4,2.2 "/>
                    <polygon  points="61.8,2.2 45.4,37 53.6,54.4 78.2,2.2 "/>
                </svg>
            </TransLinkWrapper>
            <Flex as="nav">
                <TransLinkWrapper linkLabel="Work" linkTo='/work/'>Work</TransLinkWrapper>
                <TransLinkWrapper linkLabel="What we do" linkTo='/what-we-do/'>What we do</TransLinkWrapper>
                <TransLinkWrapper linkLabel="Contact" linkTo='/contact/'>Contact</TransLinkWrapper>
            </Flex>
        </Flex>
    )
}
export default SiteHeader